<template>
  <div class="sidebar-area" :class="{ 'sidebar-collapsed': !isOpen }">
    <div class="logo-wrapper">
      <div class="logo d-flex align-items-center"
        :class="isOpen ? 'justify-content-between' : 'justify-content-center'">
        <a v-if="isOpen" href="#" class="d-block text-decoration-none">
          <img src="@/assets/logo.png" alt="logo" style="height:36px;">
        </a>
        <span v-else class="logo-icon-only">
          <img src="@/assets/logo.png" alt="logo" style="height:28px; width:28px; object-fit:contain;">
        </span>
        <button v-if="isOpen" class="sidebar-burger-menu-close bg-transparent border-0" @click="$emit('close')">
          <span class="d-block"
            style="border-bottom: 1px solid #94a3b8; height:1px; width:20px; transform:rotate(45deg);"></span>
          <span class="d-block"
            style="border-bottom: 1px solid #94a3b8; height:1px; width:20px; transform:rotate(-45deg); margin-top:-2px;"></span>
        </button>
      </div>
    </div>

    <div class="menu-wrapper" ref="menuWrapper">
      <ul class="menu-list">
        <li class="menu-item" v-if="userRole === 'reseller'">
          <router-link to="/companies/list" class="menu-link" data-tooltip="Companies">
            <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
              <span class="material-symbols-outlined menu-icon">apartment</span>
              <span v-if="isOpen" class="title">Company Management</span>
            </div>
          </router-link>
        </li>
        <template v-else>
          <template v-if="showFullMenu">
            <li class="menu-item">
              <router-link to="/dashboard" class="menu-link" data-tooltip="Dashboard">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">dashboard</span>
                  <span v-if="isOpen" class="title">Dashboard</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/wo/list" class="menu-link" data-tooltip="Templates">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">ballot</span>
                  <span v-if="isOpen" class="title">Work Orders</span>
                </div>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/wo/request/list" class="menu-link" data-tooltip="Templates">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">maps_ugc</span>
                  <span v-if="isOpen" class="title">Requests</span>
                </div>
              </router-link>
            </li>
            <li class="menu-item">
              <router-link to="/purchase-orders/list" class="menu-link" data-tooltip="Purchase Orders">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">shopping_cart</span>
                  <span v-if="isOpen" class="title">Purchase Orders</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/wo/schedule/list-all" class="menu-link" data-tooltip="Work Orders">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">assignment</span>
                  <span v-if="isOpen" class="title">All WO Schedules</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/wo/schedule/assign-to-me" class="menu-link" data-tooltip="Work Orders">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">assignment</span>
                  <span v-if="isOpen" class="title">To Do Schedules</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/template/list" class="menu-link" data-tooltip="Templates">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">assignment</span>
                  <span v-if="isOpen" class="title">Checklists/Templates</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/wo/category/list" class="menu-link" data-tooltip="Templates">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">ad_group</span>
                  <span v-if="isOpen" class="title">Work Order Categories</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/asset/category/list" class="menu-link" data-tooltip="Asset Categories">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">category</span>
                  <span v-if="isOpen" class="title">Asset Categories</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/asset/list" class="menu-link" data-tooltip="Assets">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">inventory_2</span>
                  <span v-if="isOpen" class="title">Assets</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/materials/list" class="menu-link" data-tooltip="Materials Inventory">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">precision_manufacturing</span>
                  <span v-if="isOpen" class="title">Materials Inventory</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/library/list" class="menu-link" data-tooltip="Library">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">library_books</span>
                  <span v-if="isOpen" class="title">Library</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/location/list" class="menu-link" data-tooltip="Location">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">location_on</span>
                  <span v-if="isOpen" class="title">Locations</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/team/list" class="menu-link" data-tooltip="Teams">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">request_page</span>
                  <span v-if="isOpen" class="title">Teams</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/user/list" class="menu-link" data-tooltip="Users">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">people</span>
                  <span v-if="isOpen" class="title">Users</span>
                </div>
              </router-link>
            </li>

            <li class="menu-item">
              <router-link to="/vendor/list" class="menu-link" data-tooltip="Vendors">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">store</span>
                  <span v-if="isOpen" class="title">Vendors</span>
                </div>
              </router-link>
            </li>
          </template>

          <template v-else-if="showRequesterMenu">
            <li class="menu-item">
              <router-link to="/dashboard" class="menu-link" data-tooltip="Dashboard">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">dashboard</span>
                  <span v-if="isOpen" class="title">Dashboard</span>
                </div>
              </router-link>
            </li>

            <!-- <li class="menu-item">
              <router-link to="/wo/list" class="menu-link" data-tooltip="Work Orders">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">ballot</span>
                  <span v-if="isOpen" class="title">Work Orders</span>
                </div>
              </router-link>
            </li> -->

            <li class="menu-item">
              <router-link to="/wo/request/list" class="menu-link" data-tooltip="Requests">
                <div class="menu-content" :class="{ 'menu-content-collapsed': !isOpen }">
                  <span class="material-symbols-outlined menu-icon">maps_ugc</span>
                  <span v-if="isOpen" class="title">Requests</span>
                </div>
              </router-link>
            </li>
          </template>
        </template>
      </ul>
    </div>

    <!-- User Profile Section - Bottom -->
    <div class="user-profile-wrapper" ref="profileWrapper">
      <div class="user-profile" :class="{ 'user-profile-collapsed': !isOpen, 'profile-menu-open': showSettingsMenu }">
        <div class="user-avatar">
          <span class="avatar-initials">{{ get_fname()?.[0] }}{{ get_lname()?.[0] }}</span>
          <span class="avatar-status-dot"></span>
        </div>
        <template v-if="isOpen">
          <div class="user-info text-start">
            <div class="user-name text-capitalize">
              {{ get_fname() }} {{ get_lname() }}
            </div>
            <div class="user-company">
              <i class="fa fa-building"></i> {{ companyName || 'No company' }}
            </div>
          </div>
          <button class="user-settings-btn" :class="{ active: showSettingsMenu }" @click.stop="toggleSettingsMenu"
            title="Settings">
            <span class="material-symbols-outlined settings-icon">
              {{ showSettingsMenu ? 'close' : 'settings' }}
            </span>
          </button>
        </template>
      </div>

      <!-- Settings Dropdown -->
      <transition name="menu-pop">
        <div v-if="showSettingsMenu" class="settings-menu">

          <!-- Header -->
          <div class="settings-menu-header">
            <div class="sm-avatar">
              {{ get_fname()?.[0] }}{{ get_lname()?.[0] }}
              <span class="sm-avatar-dot"></span>
            </div>
            <div class="sm-header-info">
              <div class="sm-name text-capitalize">{{ get_fname() }} {{ get_lname() }}</div>
              <div class="sm-email">{{ get_email() }}</div>
            </div>
          </div>

          <!-- Company badge -->
          <div class="sm-company-badge" v-if="companyName">
            <div class="sm-company-icon"><i class="fa fa-building"></i></div>
            <div class="sm-company-info">
              <div class="sm-company-label">Active Company</div>
              <div class="sm-company-name">{{ companyName }}</div>
            </div>
            <span class="sm-company-active-dot"></span>
          </div>

          <div class="sm-divider"></div>

          <!-- Menu items -->
          <div class="sm-menu-section">
            <div class="sm-section-label">Account</div>

            <button class="sm-item" @click="goToProfile">
              <div class="sm-item-icon icon-blue">
                <i class="fa fa-user"></i>
              </div>
              <div class="sm-item-text">
                <span class="sm-item-label">My Profile</span>
                <span class="sm-item-sub">View and edit your info</span>
              </div>
              <i class="fa fa-chevron-right sm-item-arrow"></i>
            </button>

            <button class="sm-item" @click="switchCompany">
              <div class="sm-item-icon icon-purple">
                <i class="fa fa-building"></i>
              </div>
              <div class="sm-item-text">
                <span class="sm-item-label">Switch Workspace</span>
                <span class="sm-item-sub">Change active workspace</span>
              </div>
              <i class="fa fa-chevron-right sm-item-arrow"></i>
            </button>

            <button class="sm-item">

              <div class="sm-item-icon icon-amber">
                <i class="fa fa-bell"></i>
              </div>
              <div class="sm-item-text">
                <router-link to="/notification/list" class="menu-link" data-tooltip="Notifications">
                  <span class="sm-item-label">Notifications</span>
                  <span class="sm-item-sub">Manage your alerts</span>
                </router-link>
              </div>
              <i class="fa fa-chevron-right sm-item-arrow"></i>
            </button>
          </div>

          <div class="sm-divider"></div>

          <!-- Logout -->
          <div class="sm-menu-section sm-menu-section-last">
            <button class="sm-item sm-item-danger" :disabled="loggingOut" @click="logout">
              <div class="sm-item-icon icon-red">
                <i :class="loggingOut ? 'fa fa-spinner spin' : 'fa fa-sign-out-alt'"></i>
              </div>
              <div class="sm-item-text">
                <span class="sm-item-label">{{ loggingOut ? 'Logging out…' : 'Logout' }}</span>
                <span class="sm-item-sub">End your session</span>
              </div>
            </button>
          </div>

        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '@/utils/FormSubmit'
export default {
  name: 'Sidebar',
  emits: ['close'],
  data() {
    return {
      showSettingsMenu: false,
      loggingOut: false,
      userRole: localStorage.getItem('user_role'),
    }
  },

  props: {
    isOpen: { type: Boolean, default: true }
  },
  mounted() {
    document.addEventListener('click', this.onOutsideClick)
    const menuWrapper = this.$refs.menuWrapper;
    if (!menuWrapper) return;
    const handleScroll = () => {
      menuWrapper.classList.toggle('has-scroll', menuWrapper.scrollHeight > menuWrapper.clientHeight);
    };
    handleScroll();
    this._resizeObserver = new ResizeObserver(handleScroll);
    this._resizeObserver.observe(menuWrapper);
    this._resizeHandler = handleScroll;
    window.addEventListener('resize', handleScroll);
  },

  beforeUnmount() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
    if (this._resizeHandler) window.removeEventListener('resize', this._resizeHandler);
    document.removeEventListener('click', this.onOutsideClick);
  },
  methods: {
    get_fullname() {
      return (localStorage.getItem('user_fname') ?? '---') + ' ' + (localStorage.getItem('user_lname') ?? '---')
    },

    get_fname() { return localStorage.getItem('user_fname') || '' },
    get_lname() { return localStorage.getItem('user_lname') || '' },
    get_email() { return localStorage.getItem('user_email') || '' },

    toggleSettingsMenu() {
      this.showSettingsMenu = !this.showSettingsMenu
    },

    onOutsideClick(e) {
      if (this.$refs.profileWrapper && !this.$refs.profileWrapper.contains(e.target)) {
        this.showSettingsMenu = false
      }
    },
    goToProfile() {
      this.showSettingsMenu = false;
      this.$router.push({ name: 'myProfile' });
    },

    switchCompany() {
      this.showSettingsMenu = false
      // Clear only company, keep user token
      localStorage.removeItem('company_id')
      localStorage.removeItem('company_name')
      localStorage.removeItem('company_email')
      localStorage.removeItem('company_logo')
      this.$router.push({ name: 'CompanySelect' })
    },
    async logout() {
      this.loggingOut = true

      // Call backend logout to invalidate token
      await form_api_submit({
        url: 'logout',
        method: 'POST',
        show_success_toast: false,
        show_error_toast: false,
      })

      // Clear all localStorage regardless of API result
      localStorage.clear()

      this.loggingOut = false
      this.showSettingsMenu = false

      this.$router.push('/auth/login')
    },
  },
  computed: {
    companyName() {
      return localStorage.getItem('company_name') || ''
    },
    userRoleCode() {
      return (localStorage.getItem('role_code') || '').trim()
    },
    showFullMenu() {
      return ['administrator_101', 'full_user_101'].includes(this.userRoleCode.toLowerCase())
    },
    showRequesterMenu() {
      return this.userRoleCode.toLowerCase() === 'requester_only_101'
    }
  },

}
</script>
<style scoped>
/* ── Sidebar shell ── */
.sidebar-area {
  width: 260px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: width 0.3s ease;
}

.sidebar-area.sidebar-collapsed {
  width: 60px;
}

/* ── Logo ── */
.logo-wrapper {
  flex-shrink: 0;
  border-bottom: 1px solid #e2e8f0;
}

.logo {
  padding: 0 12px;
  height: 64px;
  display: flex;
  align-items: center;
}

.logo a {
  display: flex;
  align-items: center;
}

.logo-icon-only {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ── Menu ── */
.menu-wrapper {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 0;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}

.menu-wrapper::-webkit-scrollbar {
  width: 4px;
  background: transparent;
}

.menu-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

.menu-wrapper::-webkit-scrollbar-thumb {
  background: transparent;
  border-radius: 4px;
}

.sidebar-area:hover .menu-wrapper.has-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
}

.sidebar-area:hover .menu-wrapper.has-scroll {
  scrollbar-color: #cbd5e1 #f1f5f9;
}

.menu-wrapper.has-scroll {
  scrollbar-color: transparent transparent;
}

.menu-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-item {
  list-style: none;
  margin: 2px 0;
  position: relative;
}

/* ── Menu link & content ── */
.menu-link {
  display: block;
  text-decoration: none;
  /* padding creates the click zone */
  padding: 0 8px;
}

.menu-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 8px;
  border-radius: 10px;
  transition: background 0.2s ease;
  cursor: pointer;
  white-space: nowrap;
  position: relative;
}

/* ── COLLAPSED: icon perfectly centered ── */
.menu-content-collapsed {
  justify-content: center;
  gap: 0;
  padding: 10px 0;
  width: 44px;
  /* fixed width = 60px sidebar - 2×8px link padding */
  margin: 0 auto;
  /* center within the 60px sidebar */
  border-radius: 10px;
}

/* ── Hover & active states ── */
.menu-link:hover .menu-content {
  background: #f1f5f9;
}

.menu-link:hover .menu-icon {
  color: #4f46e5;
}

.menu-link:hover .title {
  color: #4f46e5;
}

.router-link-active .menu-content {
  background: #eef2ff;
  position: relative;
}

.router-link-active .menu-content::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 60%;
  background: #4f46e5;
  border-radius: 0 2px 2px 0;
}

.router-link-active .menu-icon {
  color: #4f46e5;
}

.router-link-active .title {
  color: #4f46e5;
  font-weight: 600;
}

.menu-icon {
  font-size: 20px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  transition: color 0.2s;
  flex-shrink: 0;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  overflow: hidden;
}

/* ── Tooltip ── */
.sidebar-area.sidebar-collapsed .menu-item:hover .menu-link::after {
  content: attr(data-tooltip);
  position: fixed;
  left: 68px;
  background: #1e293b;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  padding: 5px 10px;
  border-radius: 6px;
  white-space: nowrap;
  z-index: 9999;
  pointer-events: none;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.sidebar-area.sidebar-collapsed .menu-item:hover .menu-link::before {
  content: '';
  position: fixed;
  left: 60px;
  border: 5px solid transparent;
  border-right-color: #1e293b;
  z-index: 9999;
  pointer-events: none;
}

/* ── User profile ── */
.user-profile-wrapper {
  flex-shrink: 0;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
  padding: 12px 8px;
}

.user-profile {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 8px;
  border-radius: 12px;
  transition: background 0.2s ease;
}

.user-profile-collapsed {
  justify-content: center;
  gap: 0;
  padding: 8px 0;
}

.user-profile:hover {
  background: #f1f5f9;
}

.user-avatar .material-symbols-outlined {
  font-size: 32px;
  color: #4f46e5;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.user-settings-btn {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  transition: background 0.2s;
  flex-shrink: 0;
}

.user-settings-btn .material-symbols-outlined {
  font-size: 18px;
  color: #64748b;
}

.user-settings-btn:hover {
  background: #e2e8f0;
}

.user-settings-btn:hover .material-symbols-outlined {
  color: #4f46e5;
}

.sidebar-burger-menu-close {
  cursor: pointer;
  padding: 4px !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: transparent;
  border-radius: 6px;
  transition: background 0.2s;
  flex-shrink: 0;
}

.sidebar-burger-menu-close:hover {
  background: #f1f5f9;
}

@media (max-width: 1024px) {
  .sidebar-area {
    width: 260px;
    transform: translateX(-260px);
    transition: transform 0.3s ease;
    box-shadow: none;
  }

  .sidebar-area:not(.sidebar-collapsed) {
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  }

  .sidebar-area.sidebar-collapsed {
    transform: translateX(-260px);
  }
}

@media (max-width: 768px) {
  .sidebar-area {
    width: 260px !important;
    transform: translateX(-260px);
    transition: transform 0.3s ease, width 0.3s ease;
    box-shadow: none;
  }

  .sidebar-area:not(.sidebar-collapsed) {
    transform: translateX(0);
    box-shadow: 4px 0 24px rgba(0, 0, 0, 0.12);
  }

  .sidebar-area.sidebar-collapsed {
    transform: translateX(-260px);
    width: 260px !important;
  }
}

/* dropdown styles for settings button */
/* ── User profile wrapper ──────────────────────────────────── */
.user-profile-wrapper {
  position: relative;
  padding: 8px;
}

/* ── User profile row ─────────────────────────────────────── */
.user-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border-radius: 12px;
  transition: background 0.2s;
  cursor: default;
}

.user-profile:hover,
.user-profile.profile-menu-open {
  background: rgba(255, 255, 255, 0.07);
}

/* Avatar with initials + online dot */
.user-avatar {
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: linear-gradient(135deg, #185FA5, #534AB7);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.avatar-initials {
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.avatar-status-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid var(--sidebar-bg, #1e293b);
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-name {
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-company {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 10px;
  color: #94a3b8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-company i {
  font-size: 9px;
}

/* Settings button */
.user-settings-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
  color: #94a3b8;
}

.user-settings-btn:hover,
.user-settings-btn.active {
  background: rgba(255, 255, 255, 0.1);
  color: #f1f5f9;
}

.settings-icon {
  font-size: 18px;
  transition: transform 0.3s ease;
}

.user-settings-btn.active .settings-icon {
  transform: rotate(90deg);
}

/* ── Settings menu ─────────────────────────────────────────── */
.settings-menu {
  position: absolute;
  bottom: calc(100% + 6px);
  left: 8px;
  right: 8px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow:
    0 -4px 6px rgba(0, 0, 0, 0.04),
    0 20px 40px rgba(0, 0, 0, 0.14),
    0 8px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  z-index: 999;
  min-width: 240px;
}

/* Header */
.settings-menu-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 16px 12px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.sm-avatar {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #185FA5, #534AB7);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  flex-shrink: 0;
}

.sm-avatar-dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #22c55e;
  border: 2px solid #f8fafc;
}

.sm-header-info {
  flex: 1;
  min-width: 0;
}

.sm-name {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

.sm-email {
  font-size: 11px;
  color: #64748b;
  margin-top: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Company badge */
.sm-company-badge {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.sm-company-icon {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  background: #EEEDFE;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sm-company-icon i {
  font-size: 12px;
  color: #534AB7;
}

.sm-company-info {
  flex: 1;
  min-width: 0;
}

.sm-company-label {
  font-size: 9px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #94a3b8;
}

.sm-company-name {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sm-company-active-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #22c55e;
  flex-shrink: 0;
}

/* Divider */
.sm-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 0;
}

/* Section */
.sm-menu-section {
  padding: 6px 8px;
}

.sm-menu-section-last {
  padding: 6px 8px 8px;
}

.sm-section-label {
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #94a3b8;
  padding: 6px 8px 4px;
}

/* Items */
.sm-item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 8px;
  border-radius: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  transition: all 0.15s;
  position: relative;
  overflow: hidden;
}

.sm-item::before {
  content: '';
  position: absolute;
  inset: 0;
  background: currentColor;
  opacity: 0;
  transition: opacity 0.15s;
  border-radius: 10px;
}

.sm-item:hover {
  background: #f8fafc;
}

.sm-item:active {
  transform: scale(0.98);
}

/* Item icon */
.sm-item-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.15s;
}

.sm-item:hover .sm-item-icon {
  transform: scale(1.08);
}

.sm-item-icon i {
  font-size: 13px;
}

.icon-blue {
  background: #E6F1FB;
}

.icon-blue i {
  color: #185FA5;
}

.icon-purple {
  background: #EEEDFE;
}

.icon-purple i {
  color: #534AB7;
}

.icon-amber {
  background: #FAEEDA;
}

.icon-amber i {
  color: #854F0B;
}

.icon-teal {
  background: #E1F5EE;
}

.icon-teal i {
  color: #0F6E56;
}

.icon-red {
  background: #FCEBEB;
}

.icon-red i {
  color: #A32D2D;
}

/* Item text */
.sm-item-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.sm-item-label {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  display: block;
}

.sm-item-sub {
  font-size: 10px;
  color: #94a3b8;
  display: block;
}

/* Arrow */
.sm-item-arrow {
  font-size: 10px;
  color: #cbd5e1;
  transition: transform 0.15s, color 0.15s;
}

.sm-item:hover .sm-item-arrow {
  transform: translateX(3px);
  color: #94a3b8;
}

/* Danger item */
.sm-item-danger .sm-item-label {
  color: #A32D2D;
}

.sm-item-danger .sm-item-sub {
  color: #fca5a5;
}

.sm-item-danger:hover {
  background: #fff5f5;
}

.sm-item-danger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.sm-item-danger:disabled:hover {
  background: transparent;
  transform: none;
}

/* ── Transition ───────────────────────────────────────────── */
.menu-pop-enter-active {
  transition: opacity 0.2s ease, transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.menu-pop-leave-active {
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.menu-pop-enter-from,
.menu-pop-leave-to {
  opacity: 0;
  transform: translateY(10px) scale(0.97);
}

/* ── Spin ─────────────────────────────────────────────────── */
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.spin {
  display: inline-block;
  animation: spin 0.8s linear infinite;
}
</style>